export default "__VITE_ASSET__005aaf46__"